const barcelona = [
  {
    id: 1,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2025",
      "2025 barcelona",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/25-26-01/uni0.jpg",
      "/images/europa/barcelona/25-26-01/uni1.jpg",
      "/images/europa/barcelona/25-26-01/uni2.jpg",
      "/images/europa/barcelona/25-26-01/uni3.jpg",
      "/images/europa/barcelona/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2025",
      "2025 barcelona",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/25-26-02/uni0.jpg",
      "/images/europa/barcelona/25-26-02/uni1.jpg",
      "/images/europa/barcelona/25-26-02/uni2.jpg",
      "/images/europa/barcelona/25-26-02/uni3.jpg",
      "/images/europa/barcelona/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2025",
      "2025 barcelona",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/25-26-03/uni0.jpg",
      "/images/europa/barcelona/25-26-03/uni1.jpg",
      "/images/europa/barcelona/25-26-03/uni2.jpg",
      "/images/europa/barcelona/25-26-03/uni3.jpg",
      "/images/europa/barcelona/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2025",
      "2025 barcelona",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/25-26-00-es/uni0.jpg",
      "/images/europa/barcelona/25-26-00-es/uni1.jpg",
      "/images/europa/barcelona/25-26-00-es/uni2.jpg",
      "/images/europa/barcelona/25-26-00-es/uni3.jpg",
      "/images/europa/barcelona/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2025",
      "2025 barcelona",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/25-26-00-es1/uni0.jpg",
      "/images/europa/barcelona/25-26-00-es1/uni1.jpg",
      "/images/europa/barcelona/25-26-00-es1/uni2.jpg",
      "/images/europa/barcelona/25-26-00-es1/uni3.jpg",
      "/images/europa/barcelona/25-26-00-es1/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2025",
      "2025 barcelona",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/25-26-00-es2/uni0.jpg",
      "/images/europa/barcelona/25-26-00-es2/uni1.jpg",
      "/images/europa/barcelona/25-26-00-es2/uni2.jpg",
      "/images/europa/barcelona/25-26-00-es2/uni3.jpg",
      "/images/europa/barcelona/25-26-00-es2/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2024",
      "2024 barcelona",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/24-25-01/uni0.jpg",
      "/images/europa/barcelona/24-25-01/uni1.jpg",
      "/images/europa/barcelona/24-25-01/uni2.jpg",
      "/images/europa/barcelona/24-25-01/uni3.jpg",
      "/images/europa/barcelona/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2024",
      "2024 barcelona",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/24-25-02/uni0.jpg",
      "/images/europa/barcelona/24-25-02/uni1.jpg",
      "/images/europa/barcelona/24-25-02/uni2.jpg",
      "/images/europa/barcelona/24-25-02/uni3.jpg",
      "/images/europa/barcelona/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2024",
      "2024 barcelona",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/24-25-03/uni0.jpg",
      "/images/europa/barcelona/24-25-03/uni1.jpg",
      "/images/europa/barcelona/24-25-03/uni2.jpg",
      "/images/europa/barcelona/24-25-03/uni3.jpg",
      "/images/europa/barcelona/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2024",
      "2024 barcelona",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/24-25-00-es/uni0.jpg",
      "/images/europa/barcelona/24-25-00-es/uni1.jpg",
      "/images/europa/barcelona/24-25-00-es/uni2.jpg",
      "/images/europa/barcelona/24-25-00-es/uni3.jpg",
      "/images/europa/barcelona/24-25-00-es/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 23/24 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2023",
      "2023 barcelona",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/23-24-02/uni0.jpg",
      "/images/europa/barcelona/23-24-02/uni1.jpg",
      "/images/europa/barcelona/23-24-02/uni2.jpg",
      "/images/europa/barcelona/23-24-02/uni3.jpg",
      "/images/europa/barcelona/23-24-02/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 23/24 - Uniforme de Treino",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2023",
      "2023 barcelona",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/23-24-05-t/uni0.jpg",
      "/images/europa/barcelona/23-24-05-t/uni1.jpg",
      "/images/europa/barcelona/23-24-05-t/uni2.jpg",
      "/images/europa/barcelona/23-24-05-t/uni3.jpg",
      "/images/europa/barcelona/23-24-05-t/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2022",
      "2022 barcelona",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/22-23-01/uni0.jpeg",
      "/images/europa/barcelona/22-23-01/uni1.jpeg",
      "/images/europa/barcelona/22-23-01/uni2.jpeg",
      "/images/europa/barcelona/22-23-01/uni3.jpeg",
      "/images/europa/barcelona/22-23-01/uni4.jpeg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 22/23 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2022",
      "2022 barcelona",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/22-23-02/uni0.jpg",
      "/images/europa/barcelona/22-23-02/uni1.jpg",
      "/images/europa/barcelona/22-23-02/uni2.png",
      "/images/europa/barcelona/22-23-02/uni3.png",
      "/images/europa/barcelona/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 22/23 - Uniforme 4",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2022",
      "2022 barcelona",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/22-23-04/uni0.jpg",
      "/images/europa/barcelona/22-23-04/uni1.jpg",
      "/images/europa/barcelona/22-23-04/uni2.jpg",
      "/images/europa/barcelona/22-23-04/uni3.jpg",
      "/images/europa/barcelona/22-23-04/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2021",
      "2021 barcelona",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/21-22-01/uni0.jpg",
      "/images/europa/barcelona/21-22-01/uni1.jpg",
      "/images/europa/barcelona/21-22-01/uni2.jpg",
      "/images/europa/barcelona/21-22-01/uni3.jpg",
      "/images/europa/barcelona/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2021",
      "2021 barcelona",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/21-22-02/uni0.jpg",
      "/images/europa/barcelona/21-22-02/uni1.jpg",
      "/images/europa/barcelona/21-22-02/uni2.jpg",
      "/images/europa/barcelona/21-22-02/uni3.jpg",
      "/images/europa/barcelona/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2021",
      "2021 barcelona",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/21-22-03/uni0.jpg",
      "/images/europa/barcelona/21-22-03/uni1.jpg",
      "/images/europa/barcelona/21-22-03/uni2.jpg",
      "/images/europa/barcelona/21-22-03/uni3.jpg",
      "/images/europa/barcelona/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 21/22 - Uniforme de Treino",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2021",
      "2021 barcelona",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/21-22-05-t/uni0.jpg",
      "/images/europa/barcelona/21-22-05-t/uni1.jpg",
      "/images/europa/barcelona/21-22-05-t/uni2.jpg",
      "/images/europa/barcelona/21-22-05-t/uni3.jpg",
      "/images/europa/barcelona/21-22-05-t/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 20/21 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2020",
      "2020 barcelona",
      "2020",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/20-21-01-rt/uni0.jpg",
      "/images/europa/barcelona/20-21-01-rt/uni1.jpg",
      "/images/europa/barcelona/20-21-01-rt/uni2.jpg",
      "/images/europa/barcelona/20-21-01-rt/uni3.jpg",
      "/images/europa/barcelona/20-21-01-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 20/21 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2020",
      "2020 barcelona",
      "2020",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/20-21-02-rt/uni0.jpg",
      "/images/europa/barcelona/20-21-02-rt/uni1.jpg",
      "/images/europa/barcelona/20-21-02-rt/uni2.jpg",
      "/images/europa/barcelona/20-21-02-rt/uni3.jpg",
      "/images/europa/barcelona/20-21-02-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 20/21 - Uniforme 4 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2020",
      "2020 barcelona",
      "2020",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/20-21-04/uni0.jpg",
      "/images/europa/barcelona/20-21-04/uni1.jpg",
      "/images/europa/barcelona/20-21-04/uni2.jpg",
      "/images/europa/barcelona/20-21-04/uni3.jpg",
      "/images/europa/barcelona/20-21-04/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 19/20 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2019",
      "2019 barcelona",
      "2019",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/19-20-03-rt/uni0.jpg",
      "/images/europa/barcelona/19-20-03-rt/uni1.jpg",
      "/images/europa/barcelona/19-20-03-rt/uni2.jpg",
      "/images/europa/barcelona/19-20-03-rt/uni3.jpg",
      "/images/europa/barcelona/19-20-03-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 17/18 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2017",
      "2017 barcelona",
      "2017",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/17-18-01-rt/uni0.jpg",
      "/images/europa/barcelona/17-18-01-rt/uni1.jpg",
      "/images/europa/barcelona/17-18-01-rt/uni2.jpg",
      "/images/europa/barcelona/17-18-01-rt/uni3.jpg",
      "/images/europa/barcelona/17-18-01-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 15/16 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2015",
      "2015 barcelona",
      "2015",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/15-16-03-rt/uni0.jpg",
      "/images/europa/barcelona/15-16-03-rt/uni1.jpg",
      "/images/europa/barcelona/15-16-03-rt/uni2.jpg",
      "/images/europa/barcelona/15-16-03-rt/uni3.jpg",
      "/images/europa/barcelona/15-16-03-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 14/15 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2014",
      "2014 barcelona",
      "2014",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/14-15-02-rt/uni0.jpg",
      "/images/europa/barcelona/14-15-02-rt/uni1.jpg",
      "/images/europa/barcelona/14-15-02-rt/uni2.jpg",
      "/images/europa/barcelona/14-15-02-rt/uni3.jpg",
      "/images/europa/barcelona/14-15-02-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 13/14 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2013",
      "2013 barcelona",
      "2013",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/13-14-01-rt/uni0.jpg",
      "/images/europa/barcelona/13-14-01-rt/uni1.jpg",
      "/images/europa/barcelona/13-14-01-rt/uni2.jpg",
      "/images/europa/barcelona/13-14-01-rt/uni3.jpg",
      "/images/europa/barcelona/13-14-01-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 12/13 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2012",
      "2012 barcelona",
      "2012",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/12-13-01/uni0.jpg",
      "/images/europa/barcelona/12-13-01/uni1.jpg",
      "/images/europa/barcelona/12-13-01/uni2.jpg",
      "/images/europa/barcelona/12-13-01/uni3.jpg",
      "/images/europa/barcelona/12-13-01/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 12/13 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2012",
      "2012 barcelona",
      "2012",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/12-13-03/uni0.jpg",
      "/images/europa/barcelona/12-13-03/uni1.jpg",
      "/images/europa/barcelona/12-13-03/uni2.jpg",
      "/images/europa/barcelona/12-13-03/uni3.jpg",
      "/images/europa/barcelona/12-13-03/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 11/12 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2011",
      "2011 barcelona",
      "2011",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/11-12-02-rt/uni0.jpg",
      "/images/europa/barcelona/11-12-02-rt/uni1.jpg",
      "/images/europa/barcelona/11-12-02-rt/uni2.jpg",
      "/images/europa/barcelona/11-12-02-rt/uni3.jpg",
      "/images/europa/barcelona/11-12-02-rt/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 07/08 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2007",
      "2007 barcelona",
      "2007",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/07-08-02-rt/uni0.jpg",
      "/images/europa/barcelona/07-08-02-rt/uni1.jpg",
      "/images/europa/barcelona/07-08-02-rt/uni2.jpg",
      "/images/europa/barcelona/07-08-02-rt/uni3.jpg",
      "/images/europa/barcelona/07-08-02-rt/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 01/02 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2001",
      "2001 barcelona",
      "2001",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/01-02-01-rt/uni0.jpg",
      "/images/europa/barcelona/01-02-01-rt/uni1.jpg",
      "/images/europa/barcelona/01-02-01-rt/uni2.jpg",
      "/images/europa/barcelona/01-02-01-rt/uni3.jpg",
      "/images/europa/barcelona/01-02-01-rt/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 01/02 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 2001",
      "2001 barcelona",
      "2001",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/01-02-02-rt/uni0.jpg",
      "/images/europa/barcelona/01-02-02-rt/uni1.jpg",
      "/images/europa/barcelona/01-02-02-rt/uni2.jpg",
      "/images/europa/barcelona/01-02-02-rt/uni3.jpg",
      "/images/europa/barcelona/01-02-02-rt/uni4.jpg",
    ],
  },
  {
    id: 34,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 98/99 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 1998",
      "1998 barcelona",
      "1998",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/98-99-01-rt/uni0.jpg",
      "/images/europa/barcelona/98-99-01-rt/uni1.jpg",
      "/images/europa/barcelona/98-99-01-rt/uni2.jpg",
      "/images/europa/barcelona/98-99-01-rt/uni3.jpg",
      "/images/europa/barcelona/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 35,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 1998",
      "1998 barcelona",
      "1998",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/98-99-02-rt/uni0.jpg",
      "/images/europa/barcelona/98-99-02-rt/uni1.jpg",
      "/images/europa/barcelona/98-99-02-rt/uni2.jpg",
      "/images/europa/barcelona/98-99-02-rt/uni3.jpg",
      "/images/europa/barcelona/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 36,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 97/98 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 1997",
      "1997 barcelona",
      "1997",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/97-98-02-rt/uni0.jpg",
      "/images/europa/barcelona/97-98-02-rt/uni1.jpg",
      "/images/europa/barcelona/97-98-02-rt/uni2.jpg",
      "/images/europa/barcelona/97-98-02-rt/uni3.jpg",
      "/images/europa/barcelona/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 37,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 95/96 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 1995",
      "1995 barcelona",
      "1995",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/95-96-01-rt/uni0.jpg",
      "/images/europa/barcelona/95-96-01-rt/uni1.jpg",
      "/images/europa/barcelona/95-96-01-rt/uni2.jpg",
      "/images/europa/barcelona/95-96-01-rt/uni3.jpg",
      "/images/europa/barcelona/95-96-01-rt/uni4.jpg",
    ],
  },
  {
    id: 38,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 92/93 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 1992",
      "1992 barcelona",
      "1992",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/92-93-02-rt/uni0.jpg",
      "/images/europa/barcelona/92-93-02-rt/uni1.jpg",
      "/images/europa/barcelona/92-93-02-rt/uni2.jpg",
      "/images/europa/barcelona/92-93-02-rt/uni3.jpg",
      "/images/europa/barcelona/92-93-02-rt/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 91/92 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona 1991",
      "1991 barcelona",
      "1991",
      "barcelona retro",
      "retro barcelona",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/barcelona/91-92-01-rt/uni0.jpg",
      "/images/europa/barcelona/91-92-01-rt/uni1.jpg",
      "/images/europa/barcelona/91-92-01-rt/uni2.jpg",
      "/images/europa/barcelona/91-92-01-rt/uni3.jpg",
      "/images/europa/barcelona/91-92-01-rt/uni4.jpg",
    ],
  },
  {
    id: 40,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona - Jaqueta (Azul)",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona jaqueta",
      "jaqueta barcelona",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/ja/uni0.jpg",
      "/images/europa/barcelona/ja/uni1.jpg",
      "/images/europa/barcelona/ja/uni2.jpg",
      "/images/europa/barcelona/ja/uni3.jpg",
      "/images/europa/barcelona/ja/uni4.jpg",
    ],
  },
  {
    id: 41,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona - Jaqueta (Azul/Branca)",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona jaqueta",
      "jaqueta barcelona",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/jab/uni0.jpg",
      "/images/europa/barcelona/jab/uni1.jpg",
      "/images/europa/barcelona/jab/uni2.jpg",
      "/images/europa/barcelona/jab/uni3.jpg",
      "/images/europa/barcelona/jab/uni4.jpg",
    ],
  },
  {
    id: 42,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona jaqueta",
      "jaqueta barcelona",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/jb/uni0.jpg",
      "/images/europa/barcelona/jb/uni1.jpg",
      "/images/europa/barcelona/jb/uni2.jpg",
      "/images/europa/barcelona/jb/uni3.jpg",
      "/images/europa/barcelona/jb/uni4.jpg",
    ],
  },
  {
    id: 43,
    pais: "europa",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "barcelona",
      "barça ",
      "cules",
      "barcelona jaqueta",
      "jaqueta barcelona",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/barcelona/jp/uni0.jpg",
      "/images/europa/barcelona/jp/uni1.jpg",
      "/images/europa/barcelona/jp/uni2.jpg",
      "/images/europa/barcelona/jp/uni3.jpg",
    ],
  },
];

export default barcelona;
